const styles = theme => ({
  root: {
    position: 'relative',
    padding: theme.spacing(2),
    overflow: 'hidden',
  },
  fields: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  progress: {
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
  },
  inputDescription: {
    [theme.breakpoints.up('md')]: {
      width: '40%',
      marginRight: theme.spacing(2),
    },
  },
  functionalityGroupWrapper: {
    marginTop: theme.spacing(4),
  },
  functionalityGroup: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(4, 0),
    [theme.breakpoints.up('md')]: {
      minHeight: '100px',
      alignItems: 'flex-start',
      flexDirection: 'row',
      margin: theme.spacing(8, 0),
    },
  },
  entityTitle: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      width: '25%',
    },
  },
  entityName: {
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
  },
  entityIcon: {
    fontSize: '2.2rem',
    color: theme.palette.secondary.main,
    marginLeft: '-6px',
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      fontSize: '2.8rem',
      marginBottom: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
    },
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(-1),
    },
  },
  checkBoxLabel: {
    color: theme.palette.text.secondary,
  },
  checkBoxAllLabel: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightBold,
  },
  helperText: {
    margin: theme.spacing(2, 0),
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('md')]: {
      marginLeft: '25%',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      marginLeft: '25%',
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
})

export default styles
